import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import ConversationWorkflowIndex from './index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/conversation-workflow'),
      component: SettingsWrapper,
      // VISAO-01 (D2): editar a conta é só do super admin, e esta tela edita a conta. O AutoResolve
      // e os atributos obrigatórios salvam pelo PATCH /accounts, que recusa o administrador. Não tem
      // item de menu, mas abria por link. Marcado no PAI, o guard (`to.matched.some`) fecha toda
      // rota de dentro.
      meta: { superAdminOnly: true },
      children: [
        {
          path: '',
          name: 'conversation_workflow_index',
          component: ConversationWorkflowIndex,
          meta: {
            permissions: ['administrator'],
            // ACESSO-01 (L8b): a tela salva pelo PATCH da conta (`accounts#update`), travado: o super admin.
            escopos: ['account:manage'],
          },
        },
      ],
    },
  ],
};
